import React from 'react'
import {
  Row, Col, Input, Select, Pagination, DatePicker,
  Button, Table, message, Spin, Switch,
  Checkbox
} from 'antd'
import common from '@/public/common'
import './index.less'
import { ajaxApi, netApi, netApiNo, fileDownloadApiNew } from '@/server'
import { getCookie, outformat, getSid } from '../../public/utils'
import moment from 'moment'
import '@/static/style/margin.less'
import _, { get, set } from 'lodash'
const { Option } = Select
const host = window.location.host
const urlLink = common.oldScs + '/scs'

class ReturnOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sping: false,
      data: [],
      pageNo: 0,
      pageSize: 15,
      total: 0,
      // 以下为新
      search: {
        TimeCategory: 'audittime'
      },
      statusList: [],
      typeList: [],
      visible: false,
      whList: [],
      selectedrows: [],
      downLoading: false,
    }
  }
  componentDidMount() {
    this.getWhList()
    // 默认查询前一个月的数据
    let _search = this.state.search
    _search.BeginTime = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD')
    _search.EndTime = moment(new Date()).format('YYYY-MM-DD')
    this.setState({
      search: _search
    }, () => {
      this.getStatus()
      this.getType()
      this.getList()
    })
  }
  getWhList = async () => {
    const res = await ajaxApi({
      url: `${common.scpUrl}po-return/query-warehouse`,
      params: { sid: getSid() },
    });
    this.setState({
      whList: (get(res, 'data.data') || []).map(item => { return { value: get(item, 'whid'), label: get(item, 'name') } })
    })
  }
  // 获取查询类表的状态信息
  getStatus = () => {
    netApiNo({
      url: urlLink + '/Supplier',
      params: { Diction: 226 }
    }).then(res => {
      if (res.data.error_code === 0) {
        this.setState({
          statusList: res.data.data
        })
      } else {
        message.error('获取状态失败')
      }
    })
  }
  // 获取查询类表的类别和诉求信息
  getType = () => {
    netApiNo({
      url: urlLink + '/Supplier',
      params: { Diction: 225 }
    }).then(res => {
      if (res.data.error_code === 0) {
        this.setState({
          typeList: res.data.data
        })
      } else {
        message.error('获取类别失败')
      }
    })
  }
  // 获取列表信息
  getList = () => {
    this.setState({
      sping: true
    }, () => {
      let param = {
        ...this.state.search,
        // AdminID: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null,
        SupplierCode:getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).code : null,
      }
      netApiNo({ // 获取数据总数 0.0
        url: urlLink + '/ReturnPurchase',
        action: 'getpurchasereturnforsuppliersum',
        params: param
      }).then(res => {
        if (res.data.error_code === 0) {
          this.setState({
            total: res.data.data
          })
        } else {
          message.error(res.data.error_message)
        }
      })
      netApi({
        url: urlLink + '/ReturnPurchase',
        pageIndex: this.state.pageNo,
        pageSize: this.state.pageSize,
        params: param
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.setState({
            data: typeof (res.data.data) === 'string' ? [] : res.data.data,
            sping: false
          })
        } else {
          message.error(res.data.error_message)
        }
      })
    })
  }
  // 搜索条件input框值更改
  inputChange = (name, val) => {
    let _obj = this.state.search
    _obj[name] = val.target.value
    this.setState({
      search: _obj
    })
  }
  // 搜索条件单据类型更改值
  selectChange = (name, val) => {
    let _obj = this.state.search
    _obj[name] = val
    this.setState({
      search: _obj
    })
  }
  // 时间选择
  changTime = (name, val) => {
    let _info = this.state.search
    _info[name] = val ? moment(val).format('YYYY-MM-DD') : null
    this.setState({
      search: _info
    })
  }
  // 搜索
  search = () => {
    this.setState({
      pageNo: 0,
      current: 1,
      pageSize: 15
    }, () => {
      this.getList()
    })
  }
  reset = () => {
    this.setState({
      search: {
        TimeCategory: 'audittime',
        BeginTime: moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
        EndTime: moment(new Date()).format('YYYY-MM-DD')
      }
    }, () => {
      this.getList()
    })
  }
  // 跳转退货单详情
  goDetails = (name, item) => {
    if (name === 'order') {
      if (item.ReturnCategory === '投诉片') { // 类别是投诉片，退货单详情可直接打印退货详情。做个标记
        window.open('http://' + host + '/main/returnGoods/orderDetails?PROID=' + item.PROID + '&code=' + item.PROCode + '&return=true')
      } else {
        window.open('http://' + host + '/main/returnGoods/orderDetails?PROID=' + item.PROID + '&code=' + item.PROCode)
      }
    } else {
      if (item.WHID === 68) {
        window.open('http://' + host + '/main/complaintinformationinquiry/complaint-information-inquiry?PROCode=' + item.PROCode)
      } else {
        window.open('http://' + host + '/complaint?PROID=' + item.PROID + '&code=' + item.PROCode + '&whid=' + item.WHID)
      }
    }
  }
  // 表格分页
  pageOnChange = (val) => {
    this.setState({
      pageNo: val - 1
    }, () => {
      this.getList()
    })
  }
  sizeOnchange = (current, size) => {
    this.setState({
      pageNo: current - 1,
      pageSize: size
    }, () => {
      this.getList()
    })
  }

  checkBoxChange = (type, value) => {
    let { search } = this.state
    set(search, type, value)
    this.setState({
      search,
    })
  }
  exportFun = () => {
    let { selectedrows, search } = this.state
    this.setState({ downLoading: true }, async () => {
      await fileDownloadApiNew({
        url: common.scpUrl + '/po-return/export-product-detail',
        param: {
          sid: getSid(),
          pro_ids: selectedrows.map(item => item.PROID),
          pro_code: get(search, 'PROCode'),
          whid: get(search, 'WHID'),
          bill_code: get(search, 'BillCode'),
          date_type: get(search, 'TimeCategory'),
          begin_time: get(search, 'BeginTime'),
          end_time: get(search, 'EndTime'),
          status_for_supplier: get(search, 'Status'),
          category: get(search, 'ReturnType'),
          deal_way: get(search, 'DealWay'),
        },
        filename: 'scs退货单列表导出' + moment(new Date()).format('YYYYMMDD') + '.xls',
      })
      this.setState({ downLoading: false, selectedrows: [] })
    })

  }
  render() {
    const { num, data, total, sping, search, statusList, typeList, whList, selectedrows } = this.state
    const columns = [
      {
        title: '退货单号',
        dataIndex: 'PROCode',
        width: 120,
        render: (text, record) => (
          <a onClick={this.goDetails.bind(this, 'order', record)}>{text}</a>
        )
      },
      {
        title: '仓库',
        dataIndex: 'WHName',
        render: (text, record) => text || '-'
      },
      {
        title: '是否一件代发',
        dataIndex: 'IsSupplierDelivery',
        render: (text, record) => text===1 ? "是" : "否"
      },
      {
        title: '数量',
        dataIndex: 'Quantity',
        align: 'center',
      },
      {
        title: '金额',
        dataIndex: 'POPrice',
        align: 'right',
        render: (text) => (
          <span>{(outformat(text.toFixed(2)))}</span>
        )
      },
      {
        title: '币种',
        dataIndex: 'MoneyType',
        align: 'center',
        render: (text) => (
          <span>{text || '-'}</span>
        )
      },
      {
        title: '采购员',
        dataIndex: 'AdminName'
      },
      {
        title: '类别',
        dataIndex: 'ReturnCategory',
        render: (text, record) => {
          if (record.ReturnCategory.indexOf('投诉片') > -1) {
            if (record.WHID === 68) {
              return <span>{record.ReturnCategory ? record.ReturnCategory + '（无实物）' : '-'}</span>
            } else {
              return <span>{record.ReturnCategory}</span>
            }
          } else {
            return <span>{record.ReturnCategory}</span>
          }
        }

      },
      {
        title: '处理诉求',
        dataIndex: 'PODealWay',
        render: (text) => (
          <span>{text === '退货' ? '采购退货' : text}</span>
        )
      },
      {
        title: '换货单号',
        dataIndex: 'BillCode'
      },
      {
        title: '状态',
        dataIndex: 'SupplierStatus',
        render: (text) => (
          <span style={{ color: text === '待视客退货' || text === '视客已退货，待收货' ? '#8FC92D' : '' }}>{text}</span>
        )
      },
      {
        title: '申请时间',
        dataIndex: 'AuditDate',
        render: (text) => (
          <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
        )
      },
      {
        title: '操作',
        render: (text, record) => (
          <div>
            {/* <a style={{ display: record.ReturnCategory === '投诉片' ? 'inline-block' : 'none', marginLeft: '4px' }} onClick={this.goDetails.bind(this, 'complaint', record)}>投诉详情</a> */}
            {/* <a style={{ display: record.Category !== 4 ? 'inline-block' : 'none', marginLeft: '4px' }} onClick={this.goDetails.bind(this, 'complaint', record)}>投诉详情</a> */}
            {record.Category === 4 && <a onClick={this.goDetails.bind(this, 'complaint', record)}>投诉详情</a>}
          </div>
        )
      }

    ]
    var rowSelection = {
      selectedRowKeys: selectedrows.map(item => item.PROID),
      // 分页选择项合并
      onChange: (selectedRowKeys, selectedRows) => {
        var newData = _.differenceBy(selectedrows, data, 'PROID')
        this.setState({
          selectedrows: _.concat(newData || [], ...selectedRows),
        })
      }
    }
    return (
      <div className="returnList">
        <Spin spinning={sping}>
          <div className="search">
            <Row style={{ marginBottom: '25px' }} gutter={24}>
              <Col span={24}>
                <label>退货单号：</label>
                <Input placeholder="请输入" style={{ width: '150px' }} value={search.PROCode} onChange={this.inputChange.bind(this, 'PROCode')} />
                <label className='ml16'>仓库：</label>
                <Select style={{ width: '240px' }} value={search.WHID} allowClear showSearch optionFilterProp='label' placeholder='请选择'
                  options={whList} onChange={this.selectChange.bind(this, 'WHID')}></Select>
                <label className='ml16'>换货单号：</label>
                <Input placeholder="请输入" style={{ width: '150px' }} value={search.BillCode} onChange={this.inputChange.bind(this, 'BillCode')} />
                <Select style={{ width: '120px', marginRight: '4px', marginLeft: 16 }} value={search.TimeCategory} onSelect={this.selectChange.bind(this, 'TimeCategory')}>
                  <Option value="audittime">申请时间</Option>
                  <Option value="deliverytime">退货时间</Option>
                </Select>
                <DatePicker value={search.BeginTime ? moment(search.BeginTime, 'YYYY-MM-DD') : ''} onChange={this.changTime.bind(this, 'BeginTime')} />
                至 <DatePicker value={search.EndTime ? moment(search.EndTime, 'YYYY-MM-DD') : ''} onChange={this.changTime.bind(this, 'EndTime')} />
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ display: "flex", justifyContent: "space-between" }}>
                <span>
                  <label style={{ marginLeft: 20 }}>状态：</label>
                  <Select style={{ width: '150px' }} value={search.Status} onSelect={this.selectChange.bind(this, 'Status')} placeholder="请选择">
                    <Option value="">全部</Option>
                    {
                      statusList.map(item => {
                        return <Option value={item.DictKey}>{item.DictName}</Option>
                      })
                    }
                  </Select>
                  <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;类别：</label>
                  <Select style={{ width: '100px' }} value={search.ReturnType} onSelect={this.selectChange.bind(this, 'ReturnType')} placeholder="请选择">
                    <Option value="">全部</Option>
                    <Option value='1'>退货</Option>
                    <Option value='2'>投诉片</Option>
                  </Select>
                  <label style={{ marginLeft: 16 }}>处理诉求：</label>
                  <Select style={{ width: 100 }} value={search.DealWay} onSelect={this.selectChange.bind(this, 'DealWay')} placeholder="请选择">
                    <Option value="">全部</Option>
                    {
                      typeList.map(item => {
                        return <Option value={item.DictKey}>{item.DictName}</Option>
                      })
                    }
                  </Select>
                  <label style={{ marginLeft: 16 }}>是否一件代发：</label>
                  <Select placeholder="请选择"  style={{width:260}} onSelect={this.checkBoxChange.bind(this, 'IsSupplierDelivery')} value={search.IsSupplierDelivery}>
                    <Option value={null}>全部</Option>
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                  </Select>
                </span>
                <span>
                  <Button type="primary" onClick={this.search}>查询</Button>
                  <Button style={{ margin: '0 15px' }} onClick={this.reset}>重置</Button>
                  <Button type="primary" ghost onClick={this.exportFun} loading={this.state.downLoading}>导出</Button>
                </span>
              </Col>
            </Row>
          </div>
          <div className="returnBody">
            <Table columns={columns} dataSource={data} pagination={false} rowKey={record => record.PROID} rowSelection={rowSelection} />
            <div className="pagination">
              <span className="datanum">{'共' + total + '条数据'}</span>
              <Pagination showQuickJumper showSizeChanger current={(this.state.pageNo) + 1} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
            </div>
          </div>
        </Spin>
      </div>
    )
  }
}
export default ReturnOrder



// WEBPACK FOOTER //
// ./src/pages/returnGoods/returnOrder.js